import "./App.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { routes } from "./constants/routes";
import { useAppUpdateRefresh } from "./hooks/useAppUpdateRefresh";

function App() {
  useAppUpdateRefresh();

  const router = createBrowserRouter(routes);

  return <RouterProvider router={router} />;
}

export default App;
